 
import BreadcrumbSection from "./breadcrumb-section";
import SingleBlogPost from "./single-blog-post";
import shape2 from "../../assets/images/all-img/v3/shape2.png";
import shape from "../../assets/images/all-img/blog2/shape.png";

export default function InnerSection() {
	return (
		<div className="fugu--inner-section dark-version fugu--single-blog">
			<div className="container">
				<div className="row">
					<div className="col-lg-10 offset-lg-1">
						<BreadcrumbSection />
						<SingleBlogPost />
					</div>
				</div>
			</div>
			<div className="fugu--blog-shape1">
				<img src={shape2} alt="" />
			</div>
			<div className="fugu--blog-shape3">
				<img src={shape} alt="" />
			</div>
		</div>
	);
}
